import React from 'react';
import PropTypes from 'prop-types';

import { post } from 'helpers/api';

import CreateProjectContactRoleModal from 'components/modals/create_project_contact_role_modal';

export default class ContactAddProjectContactRoleButton extends React.Component {
  static propTypes = {
    contact: PropTypes.shape({
      id: PropTypes.number.isRequired,
      contactType: PropTypes.oneOf([
        'Contacts::Company',
        'Contacts::Person'
      ]).isRequired
    }).isRequired,
    label: PropTypes.any,
    relationships: PropTypes.array.isRequired,
    onAdd: PropTypes.func.isRequired
  };

  static defaultProps = {
    label: 'Add Project Role'
  };

  state = { shown: false };

  handleAddProjectContactRole = (projectId, relationship) => {
    const { contact, onAdd } = this.props;
    const contactsContactRole = {
      contactId: contact.id,
      contactType: contact.contactType,
      parentId: projectId,
      parentType: 'Project',
      relationship: relationship
    };

    return post('/contacts/contact_roles', { contactsContactRole }).then((data) => {
      onAdd(data);
      this.handleEndAddProjectContactRole();
      return data;
    });
  }

  handleStartAddProjectContactRole = () => this.setState({ shown: true })
  handleEndAddProjectContactRole = () => this.setState({ shown: false })

  render() {
    const { contact, label, relationships, onAdd, ...props } = this.props;
    const { shown } = this.state;

    return (
      <React.Fragment>
        <button
          {...props}
          name="add-project-contact-role-button"
          type="button"
          onClick={this.handleStartAddProjectContactRole}
        >
          {label}
        </button>
        <CreateProjectContactRoleModal
          contactLabel={contact.contactType == 'Contacts::Person' ? 'Contact' : 'Company'}
          relationships={relationships}
          selectedContactCount={1}
          shown={shown}
          onCancel={this.handleEndAddProjectContactRole}
          onSubmit={this.handleAddProjectContactRole}
        />
      </React.Fragment>
    );
  }
}
